import styled from 'styled-components';

export default styled.div`
	min-height: 100%;
	scrollbar-gutter: stable;
`;

export const StyledToolbarElement = styled.section`
	.motif-icon-button .motif-icon {
		scale: 1.05;
		transform: translateY(-45%);
	}
`;